import { HubConnectionBuilder, LogLevel, HubConnectionState } from '@microsoft/signalr';

export default {
    install(Vue) {

        let reconnectEnabled = true;
        let commsEngineStartCallbacks = [];

        let reconnectionMs = 2000;
        var lockResolver;

        function getToken() { return Vue.prototype.$auth == null ? null :  Vue.prototype.$auth.token(); }

        function setupLock() {
            // This should stop the browser deciding the tab is sleeping and disconnect signalr
            // https://docs.microsoft.com/en-us/aspnet/core/signalr/javascript-client?view=aspnetcore-5.0#bsleep

            if (navigator && navigator.locks && navigator.locks.request) {
                const promise = new Promise((res) => {
                    lockResolver = res;
                });

                navigator.locks.request('kms-sk-signalr-lock', { mode: "shared" }, () => {
                    return promise;
                });
            }
        }

        async function startCommsEngineConnection() {
            try {
                console.log('starting signalr');
                if (commsEngineConnection.state != HubConnectionState.Disconnected) {
                    return;
                    //console.error('Failed to start connect with comms engine hub. State:', commsEngineConnection.state);
                }
                console.log('connecting to signalr');
                await commsEngineConnection.start();
                console.assert(commsEngineConnection.state === HubConnectionState.Connected);
                runStartCommsEngineCallbacks();
            } catch (err) {
                //console.assert(commsEngineConnection.state === HubConnectionState.Disconnected);
                console.error('Failed to connect with comms engine hub', err);
                setTimeout(() => startCommsEngineConnection(), reconnectionMs);
            }
        }



        async function handleCommsEngineConnectionClose() {
            console.error('handleCommsEngineConnectionClose - reconnect: ' + reconnectEnabled);

            if (reconnectEnabled)
                await startCommsEngineConnection();
        }



        async function handleAuthChange(isAuthenticated) {
            reconnectEnabled = isAuthenticated;
            if (isAuthenticated) {
                await startCommsEngineConnection();
            }
            else {
                await commsEngineConnection.stop();
            }
        }

        function runStartCommsEngineCallbacks() {
            console.log('runStartCommsEngineCallbacks');
            for (var i = 0; i < commsEngineStartCallbacks.length; i++)
                commsEngineStartCallbacks[i]();
        }


        function registerCommsEngineCallback(callback) {
            commsEngineStartCallbacks.push(callback);
            console.log('registerCommsEngineCallback state: ' + commsEngineConnection.state);
            if (commsEngineConnection.state == HubConnectionState.Connected) {
                callback();
            }
        }


        function handleCommsEngineConnectionReconnecting(error) {
            //Vue.notify({ type: 'alert-warning', title: `Reconnecting to signalr...`, text: `${error}` });
            //this.$emit('signalr-disconnected');
        }

        function handleCommsEngineConnectionReconnected() {
            //Vue.notify({ type: 'alert-success', title: `Reconnected to signalr` });
            runStartCommsEngineCallbacks();
            // this.$emit('signalr-connected');
        }

        const commsEngineConnection = new HubConnectionBuilder()
            .withUrl(window.signalRurl, { accessTokenFactory: getToken })
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: retryContext => {
                    return reconnectionMs;
                }
            })
            .configureLogging(LogLevel.Warning)
            .build();



        commsEngineConnection.onclose(handleCommsEngineConnectionClose);
        commsEngineConnection.onreconnecting(handleCommsEngineConnectionReconnecting);
        commsEngineConnection.onreconnected(handleCommsEngineConnectionReconnected);


        Vue.prototype.$noticeBoardHub = commsEngineConnection;
        Vue.prototype.$noticeBoardHubStartRegistration = registerCommsEngineCallback;


        setupLock();

        Vue.mixin({
            created() {
                if (!this.$parent) {
                    // This is either the root component or a component
                    // created with `new` and no parent

                    console.log('creating signalr ' + window.authRequired);

                    if (this.$auth != null && window.authRequired == true)
                        this.$watch(() => this.$auth.check(), handleAuthChange);
                    else if (window.authRequired == false)
                        startCommsEngineConnection();
                }
            }
        });
    }
}
